exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-05494608]{font-size:18px;text-align:center;line-height:1.5;margin:10px 0}.sec[data-v-05494608]{text-indent:2em}.pec[data-v-05494608]{padding-left:2em}.content[data-v-05494608]{font-style:normal;-webkit-font-feature-settings:normal;font-feature-settings:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:12px;font-family:Microsoft YaHei,Arial;line-height:24px;color:#5b5b5b;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05494608","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/auth/APIAuth/components/protocalNew/pItems/Privacy.vue
// module id = Hrj7
// module chunks = 257